import React from 'react';

const PrintExperience = ({ data, language }) => {
  return (
    <div className="hidden print:block mb-10">
      <h3 className="text-3xl font-bold text-stone-900 mb-6 flex items-center">
        <span className="w-2 h-8 bg-amber-600 mr-3 rounded"></span>
        {language === 'en' ? 'Professional Experience' : 'ประสบการณ์ทำงาน'}
      </h3>
      <div className="space-y-8">
        {data.map((exp, index) => (
          <div key={index} className="break-inside-avoid bg-white p-6 rounded-lg border-l-4 border-amber-600 shadow-sm">
            <div className="flex justify-between items-start mb-4">
              <div className="flex-1">
                <h4 className="text-xl font-bold text-stone-900 mb-1">{exp.title}</h4>
                <h5 className="text-lg text-amber-700 font-semibold mb-2">{exp.company}</h5>
                <p className="text-base text-stone-600 leading-relaxed">{exp.description}</p>
              </div>
              <div className="text-right ml-6 flex-shrink-0">
                <div className="bg-amber-100 px-4 py-2 rounded-lg mb-2">
                  <div className="text-sm font-semibold text-amber-900">{exp.period}</div>
                </div>
                <div className="text-sm text-stone-600">{exp.location}</div>
              </div>
            </div>
            
            {exp.achievements.length > 0 && (
              <div className="mt-4 pt-4 border-t border-stone-200">
                <h6 className="text-base font-bold text-stone-800 mb-3">
                  {language === 'en' ? 'Key Responsibilities:' : 'ความรับผิดชอบหลัก:'}
                </h6>
                <ul className="space-y-2 text-base">
                  {exp.achievements.map((achievement, i) => (
                    <li key={i} className="text-stone-700 flex items-start">
                      <span className="text-amber-600 mr-3 text-lg font-bold flex-shrink-0">●</span>
                      <span className="flex-1">{achievement}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PrintExperience;